"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Banda App API
 * The API for the Banda App
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstrumentControllerApi = exports.InstrumentControllerApiFactory = exports.InstrumentControllerApiFp = exports.InstrumentControllerApiAxiosParamCreator = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * InstrumentControllerApi - axios parameter creator
 * @export
 */
const InstrumentControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {number} [pageSize]
         * @param {number} [pageNumber]
         * @param {string} [sortBy]
         * @param {string} [sortOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInstrumentsGet: (searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/instruments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (searchField !== undefined) {
                localVarQueryParameter['searchField'] = searchField;
            }
            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInstrumentsIdDelete: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiInstrumentsIdDelete', 'id', id);
            const localVarPath = `/api/instruments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInstrumentsIdGet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiInstrumentsIdGet', 'id', id);
            const localVarPath = `/api/instruments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {Instrument} instrument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInstrumentsIdPut: (id, instrument, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiInstrumentsIdPut', 'id', id);
            // verify required parameter 'instrument' is not null or undefined
            (0, common_1.assertParamExists)('apiInstrumentsIdPut', 'instrument', instrument);
            const localVarPath = `/api/instruments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(instrument, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Instrument} instrument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInstrumentsPost: (instrument, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'instrument' is not null or undefined
            (0, common_1.assertParamExists)('apiInstrumentsPost', 'instrument', instrument);
            const localVarPath = `/api/instruments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(instrument, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.InstrumentControllerApiAxiosParamCreator = InstrumentControllerApiAxiosParamCreator;
/**
 * InstrumentControllerApi - functional programming interface
 * @export
 */
const InstrumentControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.InstrumentControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {number} [pageSize]
         * @param {number} [pageNumber]
         * @param {string} [sortBy]
         * @param {string} [sortOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInstrumentsGet(searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiInstrumentsGet(searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInstrumentsIdDelete(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiInstrumentsIdDelete(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInstrumentsIdGet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiInstrumentsIdGet(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {Instrument} instrument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInstrumentsIdPut(id, instrument, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiInstrumentsIdPut(id, instrument, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {Instrument} instrument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInstrumentsPost(instrument, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiInstrumentsPost(instrument, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.InstrumentControllerApiFp = InstrumentControllerApiFp;
/**
 * InstrumentControllerApi - factory interface
 * @export
 */
const InstrumentControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.InstrumentControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {number} [pageSize]
         * @param {number} [pageNumber]
         * @param {string} [sortBy]
         * @param {string} [sortOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInstrumentsGet(searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, options) {
            return localVarFp.apiInstrumentsGet(searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInstrumentsIdDelete(id, options) {
            return localVarFp.apiInstrumentsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInstrumentsIdGet(id, options) {
            return localVarFp.apiInstrumentsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {Instrument} instrument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInstrumentsIdPut(id, instrument, options) {
            return localVarFp.apiInstrumentsIdPut(id, instrument, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Instrument} instrument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInstrumentsPost(instrument, options) {
            return localVarFp.apiInstrumentsPost(instrument, options).then((request) => request(axios, basePath));
        },
    };
};
exports.InstrumentControllerApiFactory = InstrumentControllerApiFactory;
/**
 * InstrumentControllerApi - object-oriented interface
 * @export
 * @class InstrumentControllerApi
 * @extends {BaseAPI}
 */
class InstrumentControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [searchField]
     * @param {string} [searchString]
     * @param {number} [pageSize]
     * @param {number} [pageNumber]
     * @param {string} [sortBy]
     * @param {string} [sortOrder]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstrumentControllerApi
     */
    apiInstrumentsGet(searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, options) {
        return (0, exports.InstrumentControllerApiFp)(this.configuration).apiInstrumentsGet(searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstrumentControllerApi
     */
    apiInstrumentsIdDelete(id, options) {
        return (0, exports.InstrumentControllerApiFp)(this.configuration).apiInstrumentsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstrumentControllerApi
     */
    apiInstrumentsIdGet(id, options) {
        return (0, exports.InstrumentControllerApiFp)(this.configuration).apiInstrumentsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {Instrument} instrument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstrumentControllerApi
     */
    apiInstrumentsIdPut(id, instrument, options) {
        return (0, exports.InstrumentControllerApiFp)(this.configuration).apiInstrumentsIdPut(id, instrument, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Instrument} instrument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstrumentControllerApi
     */
    apiInstrumentsPost(instrument, options) {
        return (0, exports.InstrumentControllerApiFp)(this.configuration).apiInstrumentsPost(instrument, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.InstrumentControllerApi = InstrumentControllerApi;
